/**
 * @generated SignedSource<<ff07ea8a82c839b629bee443c0b1ea98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExportMenuItem_viewer$data = {
  readonly integrations: {
    readonly google: {
      readonly isActive: boolean;
    } | null;
  };
  readonly user: {
    readonly isGuest: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ExportToDocs_viewer">;
  readonly " $fragmentType": "ExportMenuItem_viewer";
};
export type ExportMenuItem_viewer$key = {
  readonly " $data"?: ExportMenuItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExportMenuItem_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportMenuItem_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GoogleUserNode",
          "kind": "LinkedField",
          "name": "google",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExportToDocs_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bdde00eaf4793291ee07faf87baa8232";

export default node;
